import React, { useState, useEffect } from "react";

import ChartItem from "./ChartItem";
import MasterFilter from "../MasterFilter";
import { CHART_ITEMS } from "../../constants";
import { getEnityNameForCAband } from "../../utils";
import { MyFilters } from "../../../dashboard/components/FilterModal/MyFilters";
import Portal from "../../../common/components/Portal";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../dashboard/actions.js";

const ChartSection = ({
    masterFilterList,
    chartSectionData,
    entity,
    selectedClient,
    isExcelExport,
    requiredFields,
    getMasterFiltersData,
    setSelectedMasterFilters,
    setFilterOpen,
    projectSectionDatas,
    filterOpen = false
}) => {
    const [chartData, setChartData] = useState([]);
    const { filterFields, masterFilterList: dashboardMasterFilterList, getBuildingTypeFilter } = useSelector(state => state.dashboardReducer);
    const [smartChartSectionData, setSmartChartSectionData] = useState(projectSectionDatas?.mfilter || {});
    const dispatch = useDispatch();
    const [isMasterFilterSubmit, setIsMasterFilterSubmit] = useState(null);
    const [isDataReady, setIsDataReady] = useState(false);
    useEffect(() => {
        setSmartChartSectionData({
            ...projectSectionDatas?.mfilter
        });
        setChartItemData(entity);
        if (Object?.keys(projectSectionDatas?.mfilter || {})?.length > 0) {
            Object.entries(projectSectionDatas?.mfilter || {})?.forEach(([key, value]) => {
                if (isMasterFilterSubmit) {
                    const names =
                        Array.isArray(value) && value.length > 0
                            ? dashboardMasterFilterList?.building_types?.filter(ms => value.includes(ms.id))?.map(item => item.name) || []
                            : [];
                    setSmartChartSectionData({ ...projectSectionDatas?.mfilter, building_types: names });
                }
            });
        }
    }, [projectSectionDatas, isExcelExport]);

    useEffect(() => {
        setChartItemData(entity);
    }, [chartSectionData]);
    useEffect(() => {
        if (filterOpen) {
            setIsMasterFilterSubmit(false);
            if (Object.keys(projectSectionDatas?.mfilter)?.includes("building_types")) {
                if (Object?.keys(projectSectionDatas?.mfilter)?.length > 0) {
                    Object.entries(projectSectionDatas?.mfilter)?.forEach(([key, value]) => {
                        if (key === "building_types") {
                            const names =
                                dashboardMasterFilterList?.building_types?.filter(ms => value?.includes(ms.id))?.map(item => item.name) || [];
                            setSmartChartSectionData({ ...projectSectionDatas?.mfilter, building_types: names });
                        }
                    });
                }
            }
            setIsDataReady(true);
        } else {
            setIsDataReady(false);
        }
    }, [filterOpen, dashboardMasterFilterList?.building_types]);

    useEffect(() => {
        if (isMasterFilterSubmit) {
            MasterFilterSubmit(isMasterFilterSubmit, false);
        }
    }, [isMasterFilterSubmit, dashboardMasterFilterList]);

    const MasterFilterSubmit = filterObjects => {
        if (filterObjects) {
            const { filters, top_n, ...rest } = filterObjects;
            filterObjects = {
                ...rest,
                ...(filters && { filters }),
                ...(top_n && { top_n })
            };
        }
        if (!filterObjects?.filters || !filterObjects?.strat_year || !filterObjects?.end_year) {
            setSelectedMasterFilters("mfilter", {
                bandName: "band1",
                entity: "project",
                removeWildcardFilter: !filterObjects?.filters,
                removeYearFilter: !filterObjects?.start_year || !filterObjects?.end_year,
                isArray: true
            });
        }
        if (Object?.keys(filterObjects)?.length > 0 && !Object?.keys(filterObjects).every(item => item === "project_ids")) {
            Object?.keys(filterObjects)?.map(paramKeys => {
                const filterDetail = filterFields?.find(({ paramKey }) => paramKey === paramKeys);
                if (Object?.keys(filterObjects)?.length > 0) {
                    if (paramKeys === "exclude_filters") return;
                    let building_ids = [];
                    if (paramKeys === "building_types") {
                        building_ids = getSystemChartParams(filterObjects);
                    }
                    setSelectedMasterFilters("mfilter", {
                        mfilterKey: paramKeys === "start_year" || paramKeys === "end_year" || paramKeys === "update_fci" ? "years" : paramKeys,
                        bandName: "band1",
                        filterValues:
                            filterObjects[paramKeys]?.length > 0
                                ? paramKeys === "building_types"
                                    ? building_ids
                                    : [...filterObjects[paramKeys]]
                                : paramKeys === "start_year"
                                ? { start: filterObjects[paramKeys] }
                                : paramKeys === "end_year"
                                ? { end: filterObjects[paramKeys] }
                                : paramKeys === "update_fci"
                                ? { update_fci: filterObjects[paramKeys] }
                                : filterObjects[paramKeys],
                        entity: "project",
                        filterKey: paramKeys === "filters" ? "filters" : paramKeys === "top_n" ? "top_n" : filterDetail?.key,
                        dropDownData: dashboardMasterFilterList?.[filterDetail?.key] || [],
                        filterLabel:
                            paramKeys === "start_year"
                                ? "Start Year"
                                : paramKeys === "end_year"
                                ? "End Year"
                                : paramKeys === "update_fci"
                                ? "update_fci"
                                : paramKeys === "filters"
                                ? "filters"
                                : paramKeys === "top_n"
                                ? "top_n"
                                : filterDetail?.label,
                        isYearFilter: paramKeys === "start_year" || paramKeys === "end_year" || paramKeys === "update_fci" || false,
                        paramKey: paramKeys === "start_year" || paramKeys === "end_year" || paramKeys === "update_fci" ? paramKeys : "",
                        isFiltersKey: Object.keys(filterObjects?.filters || {})?.length > 0 ? "filter" : paramKeys === "top_n" ? "top_n" : ""
                    });
                }
            });
        } else {
            setSelectedMasterFilters("mfilter", {
                bandName: "band1",
                entity: "project",
                isFilterValue: true
            });
        }
        setFilterOpen(false);
    };
    const getSystemChartParams = dashboardFilterParams => {
        let params = {};
        let buildingTypeData = getBuildingTypeFilter?.building_types || dashboardMasterFilterList?.building_types;
        const building_type_ids =
            buildingTypeData?.filter(item => dashboardFilterParams?.building_types?.some(elm => elm === item.name)).map(item => item.id) || [];
        if (building_type_ids?.length) {
            params = building_type_ids;
        }
        return params;
    };
    const setChartItemData = (entity = "project") => {
        let chartDataArray = [];
        let chartItemList = { ...chartSectionData.type };
        let chartKeys = Object.keys(chartItemList);
        let entityKeys = Object.keys(CHART_ITEMS[entity]);
        chartKeys.forEach(chartItem => {
            const tile = chartItemList?.[chartItem] || {};
            const isExecSumHierarchy = !!tile?.is_building_exec_sum;
            const isExecSumParent = !!tile?.exec_sum_parent_wrapper;
            const execSumBandValues = (() => {
                const b = tile.band;
                if (!b) return [];
                return Array.isArray(b) ? b : Object.values(b);
            })();
            const flatChild = isExecSumHierarchy && !isExecSumParent && execSumBandValues?.length === 1 ? execSumBandValues[0] : null;
            const isExecSumFlatImage = flatChild?.band_type === "image";
            const isExecSumFlatText = flatChild?.band_type === "text";
            chartDataArray.push({
                name:
                    chartItem.includes("user_doc") || chartItem.includes("image_doc")
                        ? chartItemList[chartItem]?.name || chartItem
                        : chartItem.includes("list_image")
                        ? chartItemList[chartItem]?.name || "Image Band"
                        : chartItem.includes("multi_recommendation")
                        ? chartItemList[chartItem]?.name || "Recommendation Summary"
                        : chartItem.includes("normal_recom")
                        ? chartItemList[chartItem]?.band1?.name || "Recommendation Table"
                        : chartItem.includes("recom_onepager")
                        ? chartItemList[chartItem]?.band1?.name || "Recommendation One Pager"
                        : chartItem.includes("asset-onepager")
                        ? chartItemList[chartItem]?.band1?.name || "Asset One Pager"
                        : chartItem.includes("memo_field")
                        ? chartItemList?.[chartItem]?.name || "Text Band"
                        : chartItem.includes("filter_report1")
                        ? chartItemList[chartItem]?.name || "Master Filters"
                        : chartItem.includes("building_report")
                        ? chartItemList[chartItem]?.band1?.name || "BBI/Stoplight Chart"
                        : chartItem.includes("addition_report")
                        ? chartItemList[chartItem]?.band1?.name || "BAI/Stoplight Chart"
                        : chartItem.includes("site_report")
                        ? chartItemList[chartItem]?.band1?.name || "BSI/Stoplight Chart"
                        : chartItem.includes("table_of_contents")
                        ? chartItemList[chartItem]?.name || "Table of Contents"
                        : chartItem.includes("sorted_recom")
                        ? chartItemList[chartItem]?.band1?.name || "Sorted Recommendation"
                        : chartItem.includes("multisystem_")
                        ? chartItemList[chartItem]?.name || "System"
                        : !entityKeys.includes(chartItem) && !isExecSumHierarchy
                        ? `Comparative Analysis Band (${
                              chartItemList[chartItem]?.year_break_down
                                  ? getEnityNameForCAband(chartItem)?.startsWith("Breakdownyears") ||
                                    getEnityNameForCAband(chartItem)?.startsWith("breakdownyears")
                                      ? `Cost by ${getEnityNameForCAband(chartItem)?.split("_")?.[1]} and Year Grouping`
                                      : `Cost by ${getEnityNameForCAband(chartItem)?.split("_")?.[0]} and Year Grouping`
                                  : chartItem?.includes("fci_benchmarking")
                                  ? getEnityNameForCAband(chartItem.split("_")?.slice(0, 2)?.join("_")) +
                                    " & " +
                                    getEnityNameForCAband(chartItem.split("_")?.[2])
                                  : getEnityNameForCAband(chartItem.split("_")?.[0]) + " & " + getEnityNameForCAband(chartItem.split("_")?.[1])
                          })` || chartItem
                        : isExecSumHierarchy
                        ? tile?.name || flatChild?.name || ""
                        : chartItem,
                docKey: chartItem,
                tileData: chartItemList?.[chartItem],
                entityIcon: isExecSumParent
                    ? "smart-chart-exec-sum-folder.svg"
                    : isExecSumFlatText
                    ? "clipboard-text.svg"
                    : getEntityIcon(
                          chartItem.includes("multisystem_") ? "system" : chartItem.includes("building_report") ? "building_report1" : chartItem,
                          entityKeys
                      ),
                isCAband:
                    !chartItem.includes("list_image") &&
                    !chartItem.includes("image_doc") &&
                    !chartItem.includes("user_doc") &&
                    !chartItem.includes("multi_recommendation") &&
                    !chartItem.includes("normal_recom") &&
                    !chartItem.includes("recom_onepager") &&
                    !chartItem.includes("asset-onepager") &&
                    !chartItem.includes("memo_field") &&
                    !chartItem.includes("building_report") &&
                    !chartItem.includes("addition_report") &&
                    !chartItem.includes("site_report") &&
                    !chartItem.includes("multisystem_") &&
                    !isExecSumHierarchy &&
                    !entityKeys.includes(chartItem),
                isMultipleRecommendation: chartItem?.includes("multi_recommendation") ? true : false,
                isRecommendation: chartItem?.includes("normal_recom") ? true : false,
                isOnePager: chartItem?.includes("recom_onepager") || chartItem?.includes("asset-onepager") ? true : false,
                isAssetOnePager: chartItem?.includes("asset-onepager"),
                isBbi: chartItem?.includes("building_report"),
                isBai: chartItem?.includes("addition_report"),
                isBsi: chartItem?.includes("site_report"),
                isMemo: chartItem?.includes("memo_field") || isExecSumFlatText,
                isExecutiveSummaryParent: isExecSumParent,
                innerHierarchyNodeId: flatChild?.band_id ?? null,
                flatBandData: flatChild || null,
                isTOC: chartItem?.includes("table_of_contents"),
                isDynamicSystem: chartItem?.includes("multisystem_"),
                isSortedRecom: chartItem?.includes("sorted_recom"),
                isDynamicBBI: chartItem?.startsWith("building_report") && chartItem !== "building_report1",
                isDynamicBSI: chartItem?.startsWith("site_report") && chartItem !== "site_report1",
                isDynamicBAI: chartItem?.startsWith("addition_report") && chartItem !== "addition_report1",
                isUserDoc: chartItem.includes("user_doc") || chartItem.includes("image_doc") ? true : false,
                isImageBand: chartItem.includes("list_image") || isExecSumFlatImage,
            });
        });
        setChartData([...chartDataArray]);
    };

    const getEntityIcon = (chartItem, entityKeys = []) => {
        if (chartItem.includes("user_doc")) {
            return "file-type-standard.svg";
        }
        if (chartItem.includes("image_doc") || chartItem.includes("list_image")) {
            return "smart-chart-image-item.svg";
        }
        if (chartItem?.includes("recom_onepager")) {
            return "sm-charts-one-pager.svg";
        }
        if (
            chartItem == "sorted_recom" ||
            chartItem == "energy_band" ||
            chartItem == "water_band" ||
            chartItem === "multi_recommendation" ||
            chartItem == "normal_recom" ||
            chartItem == "asset_band" ||
            chartItem.includes("filter_report1") ||
            !entityKeys.includes(chartItem) ||
            isExcelExport
        ) {
            return "sm-charts-table-blue-icon.svg";
        }
        return "smart-chart-chart-icon-item.svg";
    };
    const { project, ...filteredObject } = requiredFields;
    const excludedKeys = ["project_ids", "client_ids"];

    return (
        <div class="drag-main mt-1">
            <div class="row m-0">
                {filteredObject?.[entity] &&
                    filteredObject[entity]?.some(key => !excludedKeys?.includes(key)) &&
                    Array(Math.ceil(filteredObject?.[entity]?.length / 5))
                        .fill()
                        ?.map((row, rowIndex) => (
                            <MasterFilter
                                getSmartChartMasterFilterDropDown={getMasterFiltersData}
                                masterFilterList={masterFilterList?.[entity]}
                                setSmartChartData={setSelectedMasterFilters}
                                currentBand={"band1"}
                                selectedFiltersList={chartSectionData?.mfilter}
                                selectedClient={selectedClient}
                                entity={entity}
                                rowIndex={rowIndex}
                                isCoreReportView
                                requiredFields={requiredFields}
                                core_report_req_filters={chartSectionData?.core_report_req_filters}
                            />
                        ))}
            </div>
            <div class="row m-0">
                <div class="col-md-12 p-0">
                    {Array(Math.ceil(chartData.length / 4 + (chartData.length % 4 ? 1 : 0)))
                        .fill()
                        .map((dropRow, index) => (
                            <div className="dragble-area">
                                {chartData.slice(index * 4, (index + 1) * 4).map((item, i) => {
                                    return <ChartItem index={i} item={item} currentBand={"band1"} entity={entity} />;
                                })}
                            </div>
                        ))}
                </div>
            </div>
            {filterOpen && isDataReady ? (
                <Portal
                    body={
                        <MyFilters
                            dashboardFilterParams={smartChartSectionData}
                            onCancel={() => setFilterOpen(false)}
                            submitMasterFilter={filterObjects => {
                                setIsMasterFilterSubmit(filterObjects);
                            }}
                            requiredFields={requiredFields?.project}
                            core_report_req_filters={projectSectionDatas?.core_report_req_filters}
                            filterName={chartSectionData?.filter_label || {}}
                            isCoreReportFilters
                        />
                    }
                    onCancel={() => this.setState({ showFiltersPopup: false })}
                />
            ) : null}
        </div>
    );
};
export default ChartSection;
